import Vue from 'vue';
import Vuex from 'vuex';
import utils from '../modules/utils';
import jwtDecode from 'jwt-decode';
import estructura from '../views/estructura/store/index';
import destacados from '../views/acciones-movimientos/store/index';
import reporteria from '../views/planilla/reporteria/store';
import planilla from '../views/planilla/gestion-planilla/store/index';
import sanciones from '../views/sanciones/store/index';
import sancionesRecursosHumanos from '../views/sanciones/store/sancionesRecursosHumanos';
import sancionesSolicitud from '../views/sanciones/store/sancionesSolicitud';
import sancionesExpediente from '../views/sanciones/store/sancionesExpediente';
import sancionesSolicitudTitular from '../views/sanciones/store/sancionesSolicitudTitular';
import formularioSeleccionPlaza from '../views/acciones-movimientos/formulario_seleccion_plaza/store/store.js'
import constancias from '../views/constancias/store/index';
import solicitudFunciones from '../views/solicitud-funciones/store/index';
import consultoriaControlActividades from '../views/consultorias/control-actividades-jefatura/store/store.js'
import crearEntregablesRrhh from '../views/consultorias/crear-entregables-rrhh/store/store.js'
import prorrogaEntregable from '../views/consultorias/prorroga-entregable/store/store.js'
import solicitudRemoverFunciones from '../views/solicitud-funciones/store/removerFunciones';
import completarPerfil from '../views/consultorias/perfil/store/store.js'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    userInfo: {},
    expiracionToken: false,

    infoInstitucionLogo:{
      posee_logo: null,
      es_configurador: null,
      posee_establecimientos: null,
    }
  },
  mutations: {
    setToken(state, payload) {
      state.token = payload;
    },
    setUserInfo(state, payload) {
      state.userInfo = payload;
    },
    setExpiracionToken(state) {
      let fechaExpiracion = new Date(state.userInfo.exp * 1000);
      let fechaActual = new Date();
      state.expiracionToken = fechaActual > fechaExpiracion;
    },
    setInfoInstitucionLogo(state, payload) {
      state.infoInstitucionLogo = payload;
    },
  },
  actions: {
    setAuth({ commit }, payload) {
      const { token, refreshToken } = payload;

      commit('setUserInfo', jwtDecode(token));
      commit('setToken', token);
      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refreshToken);
    },
  },
  modules: {
    utils,
    estructura,
    destacados,
    reporteria,
    planilla,
    sanciones,
    sancionesRecursosHumanos,
    sancionesSolicitud,
    sancionesSolicitudTitular,
    sancionesExpediente,
    formularioSeleccionPlaza,
    constancias,
    solicitudFunciones,
    consultoriaControlActividades,
    crearEntregablesRrhh,
    prorrogaEntregable,
    solicitudRemoverFunciones,
    completarPerfil,
  },
});
